import { Injectable, Injector } from '@angular/core';
import { Report } from '../../core/declarations/report.interface';
import {
  DefineRepositoryParams,
  RepositoryAbstract
} from './repository.abstract';

type ReportRepositoryParams = DefineRepositoryParams<Report>;

@Injectable({
  providedIn: 'root'
})
export class ReportRepository extends RepositoryAbstract<ReportRepositoryParams> {
  constructor(injector: Injector) {
    super('reports', injector);
  }
}
